module.exports = __webpack_public_path__ + "img/SmallArrow.c398b55c.svg";